import { render, staticRenderFns } from "./GestaoInventarioUpdateStatusModal.vue?vue&type=template&id=3969e088"
import script from "./GestaoInventarioUpdateStatusModal.vue?vue&type=script&lang=js"
export * from "./GestaoInventarioUpdateStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports